export enum JobState {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  NOTSET = "NOTSET"
}
